import React from 'react';
import { Layout } from 'antd';
const { Footer } = Layout;
const FooterComponent = () => {
  return (
    <Footer style={{ textAlign: 'center', background: '#001529', color: 'white'  }}>
      @copyright Shakti
    </Footer>
  );
};

export default FooterComponent;
